import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanLoad, CanActivate, Route, Router, RouterStateSnapshot } from '@angular/router';
import { AdalService } from 'ng2-adal/dist/core';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppConfigService } from '../services/app.config';
import { removeObj } from '../global';
import { AzureClient } from '../services/azure-client.service';

@Injectable()
export class AuthGuard implements CanActivate, CanLoad {
    private deviceInfo = null;
    private SupportedBrowsers: string[] = ['chrome', 'firefox', 'safari', 'ms-edge', 'MS-Edge-Chromium'];
    private isBrowserSupported: boolean = false;

    constructor(private router: Router,
        private adal: AdalService,
        private config: AppConfigService,
        private azure: AzureClient,
        private deviceService: DeviceDetectorService) {

        this.azure.azureLogin$.subscribe((data: any) => {
            var redirectUrl = localStorage.getItem('redirect');

            if (redirectUrl) {
                this.router.navigate([redirectUrl]);
                localStorage.removeItem('redirect');
            }
            else {
                this.router.navigate(['/home']);
            }
        });

        this.detectBrowser();
        this.adal.init(this.config.adalConfig);
        this.adal.handleWindowCallback();
        this.adal.getUser();
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        if (this.isAuthenticated && this.isBrowserSupported)
            return true;

        localStorage.setItem('redirect', state.url);

        if (!this.isBrowserSupported)
            this.router.navigate(['browser-support']);
        else
            this.router.navigate(['']);

        return false;
    }

    canLoad(route: Route): boolean {
        if (this.isAuthenticated && this.isBrowserSupported)
            return true;

        if (!this.isBrowserSupported)
            this.router.navigate(['browser-support']);
        else
            this.router.navigate(['']);
        return false;
    }

    public get isAuthenticated(): boolean {
        return this.adal.userInfo.isAuthenticated;
    }

    private detectBrowser() {
        this.deviceInfo = this.deviceService.getDeviceInfo();

        if (this.deviceInfo)
            this.isBrowserSupported = this.SupportedBrowsers.findIndex(browser => browser.toUpperCase() === this.deviceInfo.browser.toUpperCase()) >= 0;
    }

    public login() {
        if (this.isAuthenticated) {
            this.azure.login();
        }
        else {
            this.adal.login();
        }
    }

    public logout() {
        removeObj('me');
        removeObj('azure-user');
        this.adal.logOut();
    }
}